export default "__VITE_ASSET__f9bbcdb2__"